import gql from "graphql-tag";

import { required } from "api/boundary";

export const ACCOUNT_DETAILS_FRAGMENT = {
  query: gql`
    fragment AccountDetails on Account {
      email
      firstName
      languages
      lastName
      preferredLanguage
      profilePicture
      uuid
      viewedModals
      insertedAt
    }
  `,
  parse: {
    uuid: required(),
    email: required(),
  },
};

export const ORGANISATION_ACCOUNT_DETAILS_FRAGMENT = {
  query: gql`
    fragment OrganisationAccountDetails on OrganisationAccount {
      isAdmin
      role
      account {
        ...AccountDetails
      }
    }

    ${ACCOUNT_DETAILS_FRAGMENT.query}
  `,
  parse: {
    account: ACCOUNT_DETAILS_FRAGMENT.parse,
  },
};

export const UI_ACCOUNT_PREFERENCES_QUERY = gql`
  query GetUiAccountPreferences($numberUuid: ID!, $accountUuid: ID!) {
    uiAccountPreferences(numberUuid: $numberUuid, accountUuid: $accountUuid) {
      numberUuid
      accountUuid
      inboxUseLivebox
    }
  }
`;

export const UPSERT_UI_ACCOUNT_PREFERENCE = gql`
  mutation SetUiAccountPreference($numberUuid: ID!, $accountUuid: ID!, $preferences: UiAccountPreferencesInput!) {
    upsertUiAccountPreference(numberUuid: $numberUuid, accountUuid: $accountUuid, preferences: $preferences) {
      numberUuid
      accountUuid
      inboxUseLivebox
    }
  }
`;
